import React, { useEffect, useState, useContext } from 'react';
import ReactSelect from 'react-select';
import { Link } from 'react-router-dom';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { useFormik } from 'formik';
import SearchService from './SearchGroup';
import { toast } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import SearchGroup from './SearchGroup';
import { confirm } from "react-confirm-box";
import { Context } from '../../context/UserContext';



const initialValues = {
    serviceId: 0
}



const Index = () => {

    const context = useContext(Context);
    const [serviceId, setServiceId] = useState(0);
    const [opinionId, setOpinionId] = useState(0);
    const [deliveryType, setDeliveryType] = useState(0);

    const { readData: readDataBusiness } = useEntityCrud('Business/GetAllBusiness')
    const { readDataByFilter: readDataService } = useEntityCrud('Service/GetAllservices')
    const { statusData: changeStatus } = useEntityCrud("Service/ChangeStatus")
    const { readDataByFilter: readDataGroup } = useEntityCrud('Group/GetAllGroups')
    const { readData: getOpinions } = useEntityCrud('Opinions/getAll')
    const { readDataById: readOpinionData } = useEntityCrud(`Opinions/getServiceOpinion?serviceId=${serviceId}`)

    const { readData: setServiceOpinion } = useEntityCrud(`Opinions/AddService?opinionId=${opinionId.value}&serviceId=${serviceId}`)
    const { readData: removeServiceOpinion } = useEntityCrud(`Opinions/DeleteService?serviceId=${serviceId}`)

    const { addData: addServiceDelivery } = useEntityCrud(`Service/SetServiceDelivery`)

    const roleIds = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user'))?.roleId : []


    const [opinios, setOpinions] = useState([]);
    const [currentOpinion, setCurrentOpinion] = useState({});
    const [businessList, setBusinessList] = useState([]);
    const [data, setData] = useState([])
    const [groupList, setGroupList] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [filterBTN, setFilterBTN] = useState(false);
    const [orgAddress, setOrgAddress] = useState({
        buisnessId: "",
        groupId: ""
    })
    const navigate = useNavigate();


    const getData = (searchedData) => {
        setLoading(true)
        const postedData = {
            pageNumber: 1,
            take: 10,
            ...searchedData
        };
        readDataService(postedData).then(res => {
            setLoading(false)
            if (res.data.result) {
                setData(res.data.result);
            } else {
                setData([]);
            }
        });
    }

    useEffect(() => {
        getData();
        readDataBusiness().then(res => {
            setBusinessList(res.data.result)
        });
        getOpinions().then(({ data }) => {
            setOpinions(data.result.map(item => ({ value: item.id, label: item.title })));
        })

    }, [])


    useEffect(() => {

        const postedData = {
            buisnessId: localStorage.getItem("searchDetailsBuinessID"),
        };
        readDataGroup(postedData).then(res => {
            setGroupList(res.data.result)
        });

    }, [localStorage.getItem("searchDetailsBuinessID"), businessList])



    useEffect(() => {

        const postedData = {
            groupId: localStorage.getItem("searchDetailsGroupID")
        };
        readDataService(postedData).then(res => {
            setData(res.data.result)
        })

    }, [localStorage.getItem("searchDetailsGroupID"), businessList])


    const handleManagerID = (value) => {
    }

    const onSubmit = (values) => {
        debugger
        setFilterBTN(true)
        const postedData = {
            groupId: orgAddress.groupId.value,
        };
        if (postedData.groupId) {

            readDataService(postedData).then(res => {
                debugger
                if (res.status === 200) {
                    if (res.data.status === false) {
                        res.data.errors.map(error => toast.error(error.message));
                    }
                    else {
                        setData(res.data.result)
                        if (res.data.result.length === 0) {
                            toast.error('در این گروه، سرویسی موجود نمی باشد');
                        }
                        window.localStorage.setItem("searchDetailsBuinessID", orgAddress.buisnessId.value || localStorage.getItem("searchDetailsBuinessID"));
                        window.localStorage.setItem("searchDetailsGroupID", orgAddress.groupId.value);
                    }
                } else
                    res.data.errors.map(error => toast.error(error.message));
            })
        }
    }

    const formik = useFormik({
        onSubmit,
        initialValues
    });

    const options = {
        render: (message, onConfirm, onCancel) => {
            return (
                <>
                    <h4 className="mb-3" style={{ fontSize: "20px" }}>{message} </h4>
                    <button className='btn btn-primary mx-1 px-4 py-2' onClick={onConfirm}> بله </button>
                    <button className='btn btn-secondary  px-4 mx-1  py-2' onClick={onCancel}> خیر </button>
                </>
            );
        }
    };


    const handleRemove = async (itemId, currentStatusId, groupId) => {
        /*   const result = await confirm(
              currentStatusId === 1 ? "  آیا از غیر فعال کردن خدمت مورد نظر اطمینان دارید؟ " : "  آیا از  فعال کردن خدمت مورد نظر اطمینان دارید؟ ", options);
   */
        /*     if (result) { */
        const body = {
            id: itemId,
            status: currentStatusId === 1 ? false : true
        }
        changeStatus(body).then(res => {
            const newData = data.map(item => {
                if (item.id === itemId)
                    return { ...item, isActive: currentStatusId === 1 ? 0 : 1 }
                else
                    return item
            })
            toast.success('وضعیت سرویس مورد نظر با موفقیت به روزرسانی شد');
            setData(newData);

        }).catch(err => {
            toast.error(<p className='rtl-input'>'متاسفانه سرویس حذف نشد'</p>)
        })
/*         }
 */    }

    const getOpinionDetails = serviceId => {
        setServiceId(serviceId);
    }

    const updateServiceOpinion = () => {
        setServiceOpinion().then(({ data }) => {
            if (data.status && data.result)
                toast.success('سرویس با موفقیت به نظرسنجی اضافه شد');
            else
                toast.error('انجام عملیات ناموفق بود');
            setServiceId(0);
        })
    }

    const deleteServiceOpinion = () => {
        removeServiceOpinion().then(({ data }) => {
            if (data.status && data.result)
                toast.success('حذف سرویس از نظرسنجی با موفقیت انجام شد');
            else
                toast.error('انجام عملیات ناموفق بود');
            setServiceId(0);

        })
    }

    useEffect(() => {
        if (serviceId != 0) {
            readOpinionData().then(({ data }) => {
                setCurrentOpinion(data.result || {});
            })
        } else {
            setCurrentOpinion({});
            setServiceId(0);
            setOpinionId(0);
            setCurrentOpinion(0);
        }
    }, [serviceId])

    const submitDeliveryType = (idService) => {
        debugger
        const postedData = {
            "title": deliveryType === 1 ? "حضوری" : deliveryType === 2 ? "پیک" : "حضوری - پیک",
            "id": idService,
            "deliverType": deliveryType
        }
        addServiceDelivery(postedData).then(({ data }) => {
            debugger
            if (data.status) {
                toast.success("ثبت با موفقیت انجام شد.")
            } else {
                toast.error(data.message)
            }
        })


    }


    return (
        <>
            {/*      <div class="page-header my-0">
                <h1 class="page-title">خدمت ها</h1>
            </div> */}
            <div className="card">
                <div className="card">
                    <div className="card-header p-2 py-4">
                        <h3 className="card-title">
                            {/*             
                                            <i className='fa fa-list px-1'></i>

 */}

                            سرویس ها
                        </h3>
                    </div>
                    <div className="card-body">
                        {context.checkHasPermission('create') ? <Link className="btn btn-primary mb-2" to="create">ایجاد سرویس</Link> : ''}

                        <div class="alert alert-info" role="alert">
                            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-hidden="true">×</button>
                            <i class="fa fa-bell-o me-2" aria-hidden="true"></i>
                            جهت نمایش لیست سرویس ها لطفا یک  گروه را انتخاب کنید.
                        </div>

                        <SearchGroup formik={formik}
                            data={data} setData={setData}
                            groupList={groupList} setGroupList={setGroupList}
                            businessList={businessList} setBusinessList={setBusinessList}
                            orgAddress={orgAddress} setOrgAddress={setOrgAddress}
                            filterBTN={filterBTN} setFilterBTN={setFilterBTN} />

                        {isLoading ?
                            <div class="lds-facebook" >
                                <div></div>
                                <div></div>
                                <div></div>
                            </div >
                            :
                            <>
                                {data?.length > 0 ? (localStorage.getItem('rl') != 3 ? <div class="table-responsive">
                                    <table class="table table-hover border text-nowrap text-md-nowrap table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <th width="1%"  >ردیف</th>
                                                <th>گروه</th>
                                                <th>عنوان سرویس</th>
                                                <th>  وضعیت</th>
                                                <th>عملیات</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data.map((item, index) =>
                                                <tr>
                                                    <td className='text-center'>1</td>
                                                    <td> {groupList.find(element => element.id === (orgAddress.groupId.value || parseInt(localStorage.getItem("searchDetailsGroupID"))))?.title} </td>
                                                    <td> {item.title} </td>
                                                    {/*                                                     <td>  {item.isActive === true ? "فعال" : "غیر فعال"} </td>
 */}                                                    <td>{item.isActive === 1 ? <i className="fe fe-check text-success"></i> : <i className="fe fe-x text-danger"></i>}</td>

                                                    <td>

                                                        {context.checkHasPermission('update') ? <Link to={`update/${item.id}`} className="btn btn-icon mb-0 btn-primary  mx-1">
                                                            <i className="fe fe-edit-2"></i>
                                                        </Link> : ''}

                                                        {/*     <button
                                                            className="btn btn-danger d-inline m-1 btn-icon d-inline"
                                                            type="button"
                                                            variant="danger"
                                                            onClick={() => handleRemove(item.id, item.isActive, item.groupId)}
                                                        >
                                                            {item.isActive === 1 ?
                                                                <i className="fe fe-x text-white"></i>
                                                                :
                                                                <i className="fe fe-check text-white"></i>
                                                            }
                                                        </button> */}

                                                        {context.checkHasPermission('delete') ? (item.isActive === 1 ?
                                                            <button onClick={() => handleRemove(item.id, item.isActive, item.groupId)}
                                                                className="btn btn-icon mb-0 btn-danger" title="غیرفعال سازی">
                                                                <i className="fe fe-x"></i>
                                                            </button>
                                                            : <button onClick={() => handleRemove(item.id, item.isActive, item.groupId)}
                                                                className="btn btn-icon mb-0 btn-success" title="فعال سازی">
                                                                <i className="fe fe-check"></i>
                                                            </button>) : ''
                                                        }

                                                        <button className="btn btn-info btn-icon mx-1"
                                                            data-bs-toggle="modal"
                                                            title="روش ارسال"
                                                            href={`#modaldemo${item.id}`}>
                                                            <i className="fa fa-bicycle"></i>
                                                        </button>

                                                        {context.checkHasPermission('create') || context.checkHasPermission('update') ? <button className="btn btn-warning mx-1" data-bs-toggle="modal" data-bs-target="#opinion-modal" onClick={() => getOpinionDetails(item.id)}>مدیریت نظرسنجی</button> : ''}


                                                        <div class="modal fade text-right" id={`modaldemo${item.id}`}>
                                                            <div class="modal-dialog modal-dialog-centered " role="document">
                                                                <div class="modal-content modal-content-demo">
                                                                    <div class="modal-header">
                                                                        <h6 class="modal-title">   روش ارسال

                                                                        </h6>
                                                                        <button aria-label="Close" class="btn-close" data-bs-dismiss="modal">
                                                                            <span aria-hidden="true ">&times;</span></button>
                                                                    </div>
                                                                    <div class="modal-body text-right my-4">

                                                                        <h4 className='pb-4'>
                                                                            برای سرویس خود روش ارسال را انتخاب کنید .
                                                                        </h4>

                                                                        <label className="custom-control custom-radio">
                                                                            <input type="radio" className="custom-control-input"
                                                                                name="payment-type" value="1" checked={item.deliverType == 1}
                                                                                onChange={e => setDeliveryType(1)} />
                                                                            <span className="custom-control-label">حضوری   </span>
                                                                        </label>

                                                                        <label className="custom-control custom-radio">
                                                                            <input type="radio" className="custom-control-input"
                                                                                name="payment-type" value="2" checked={item.deliverType == 2}
                                                                                onChange={e => setDeliveryType(2)} />
                                                                            <span className="custom-control-label">پیک    </span>
                                                                        </label>

                                                                        <label className="custom-control custom-radio">
                                                                            <input type="radio" className="custom-control-input"
                                                                                name="payment-type" value="3" checked={item.deliverType == 3}
                                                                                onChange={e => setDeliveryType(3)} />
                                                                            <span className="custom-control-label">حضوری - پیک    </span>
                                                                        </label>

                                                                    </div>


                                                                    <div class="modal-footer">
                                                                        <button className="btn btn-success btn-icon mx-auto px-4"
                                                                            onClick={() => submitDeliveryType(item.id)}>
                                                                            ثبت
                                                                        </button>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>


                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div> : <div className="row">
                                    {data.map((item, index) => (
                                        <div className="col-md-6" key={index}>
                                            <div className="card custom-border-1">
                                                <div className="row">
                                                    <div className="col-md-4"><p>گروه: {groupList.find(element => element.id === (orgAddress.groupId.value || parseInt(localStorage.getItem("searchDetailsGroupID"))))?.title}</p></div>
                                                    <div className="col-md-4"><p>عنوان سرویس: {item.title}</p></div>
                                                    <div className="col-md-4"><p>وضعیت: {item.isActive === 1 ? <span className="text-success">فعال</span> : <span className="text-danger">غیرفعال</span>}</p></div>
                                                </div>
                                                <div className="operation-btn-group">
                                                    {context.checkHasPermission('update') ? <Link to={`update/${item.id}`} className="btn btn-icon mb-0 btn-primary  mx-1">
                                                        <i className="fe fe-edit-2"></i>
                                                    </Link> : ''}

                                                    {/*     <button
                                                            className="btn btn-danger d-inline m-1 btn-icon d-inline"
                                                            type="button"
                                                            variant="danger"
                                                            onClick={() => handleRemove(item.id, item.isActive, item.groupId)}
                                                        >
                                                            {item.isActive === 1 ?
                                                                <i className="fe fe-x text-white"></i>
                                                                :
                                                                <i className="fe fe-check text-white"></i>
                                                            }
                                                        </button> */}

                                                    {context.checkHasPermission('delete') ? (item.isActive === 1 ?
                                                        <button onClick={() => handleRemove(item.id, item.isActive, item.groupId)}
                                                            className="btn btn-icon mb-0 btn-danger">
                                                            <i className="fe fe-x"></i>
                                                        </button>
                                                        : <button onClick={() => handleRemove(item.id, item.isActive, item.groupId)}
                                                            className="btn btn-icon mb-0 btn-success">
                                                            <i className="fe fe-check"></i>
                                                        </button>) : ''
                                                    }

                                                    <button className="btn btn-info btn-icon mx-1"
                                                        data-bs-toggle="modal"
                                                        href={`#modaldemo${item.id}`}>
                                                        <i className="fa fa-bicycle"></i>
                                                    </button>

                                                    {context.checkHasPermission('create') || context.checkHasPermission('update') ? <button className="btn btn-warning mx-1" data-bs-toggle="modal" data-bs-target="#opinion-modal" onClick={() => getOpinionDetails(item.id)}>مدیریت نظرسنجی</button> : ''}


                                                    <div class="modal fade text-right" id={`modaldemo${item.id}`}>
                                                        <div class="modal-dialog modal-dialog-centered " role="document">
                                                            <div class="modal-content modal-content-demo">
                                                                <div class="modal-header">
                                                                    <h6 class="modal-title">   روش ارسال

                                                                    </h6>
                                                                    <button aria-label="Close" class="btn-close" data-bs-dismiss="modal">
                                                                        <span aria-hidden="true ">&times;</span></button>
                                                                </div>
                                                                <div class="modal-body text-right my-4">

                                                                    <h4 className='pb-4'>
                                                                        برای سرویس خود روش ارسال را انتخاب کنید .
                                                                    </h4>

                                                                    <label className="custom-control custom-radio">
                                                                        <input type="radio" className="custom-control-input"
                                                                            name="payment-type" value="1"
                                                                            onChange={e => setDeliveryType(1)} />
                                                                        <span className="custom-control-label">حضوری   </span>
                                                                    </label>

                                                                    <label className="custom-control custom-radio">
                                                                        <input type="radio" className="custom-control-input"
                                                                            name="payment-type" value="2"
                                                                            onChange={e => setDeliveryType(2)} />
                                                                        <span className="custom-control-label">پیک    </span>
                                                                    </label>

                                                                    <label className="custom-control custom-radio">
                                                                        <input type="radio" className="custom-control-input"
                                                                            name="payment-type" value="3"
                                                                            onChange={e => setDeliveryType(3)} />
                                                                        <span className="custom-control-label">حضوری - پیک    </span>
                                                                    </label>

                                                                </div>


                                                                <div class="modal-footer">
                                                                    <button className="btn btn-success btn-icon mx-auto px-4"
                                                                        onClick={() => submitDeliveryType(item.id)}>
                                                                        ثبت
                                                                    </button>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                ) : ""}
                                <div class="modal effect-scale" id="opinion-modal" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-centered" role="document">
                                        <div class="modal-content modal-content-demo">
                                            <div class="modal-header">
                                                <h6 class="modal-title">مدیریت نظرسنجی</h6>
                                            </div>
                                            <div class="modal-body">
                                                <p>نظرسنجی فعلی : {currentOpinion.title || 'بدون نظرسنجی فعال'}</p>
                                                <hr />
                                                <div className="form-group">
                                                    <label>تغییر نظرسنجی</label>
                                                    <ReactSelect label="نظرسنجی"
                                                        options={opinios}
                                                        value={opinionId}
                                                        onChange={(value) => setOpinionId(value)}
                                                        placeholder="انتخاب کنید"
                                                        name="opinionId"
                                                    />
                                                </div>
                                                <button className="btn btn-success" data-bs-dismiss="modal" type="button" onClick={updateServiceOpinion}>به روزرسانی نظرسنجی</button>
                                                <button className="btn btn-danger mx-2" data-bs-dismiss="modal" type="button" onClick={deleteServiceOpinion}>حذف از نظرسنجی</button>
                                            </div>
                                            <div className="modal-footer">
                                                <button className="btn btn-danger" data-bs-dismiss="modal" type="button">لغو</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                    </div>

                </div>
            </div>
        </>
    );
}

export default Index;